import previewPaneStore from '../store/Store';

export default function getPreviewPaneViewState() {
    return previewPaneStore.viewState;
}
